exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3PWs70gsVsnuMxU58uS8SD{width:clamp(470px, 50%, 700px)}._3YAocbrEQjk7JxAI-JLjin{width:100%;border-collapse:collapse}._3YAocbrEQjk7JxAI-JLjin thead{background-color:#eee}._3YAocbrEQjk7JxAI-JLjin th{font-weight:500;font-size:14px;line-height:20px;padding:10px 20px;text-align:left}._3YAocbrEQjk7JxAI-JLjin td{border:1px solid #e0e0e0;padding:10px 20px}._3YAocbrEQjk7JxAI-JLjin tr._1R5ryUNB661i5JfktIbomC td{text-decoration:line-through}\n", ""]);

// Exports
exports.locals = {
	"quickstats": "_3PWs70gsVsnuMxU58uS8SD",
	"participantsTable": "_3YAocbrEQjk7JxAI-JLjin",
	"strikethrough": "_1R5ryUNB661i5JfktIbomC"
};